export const siteInfo = {
  name: "瓜田社区",
  slogan: "有瓜一起吃，有话大家聊",
  intro:
    "瓜田社区是一个为中文网民准备的线上唠嗑现场，汇聚今日话题、热帖推荐与讨论版精华内容。无论你想追热点、聊日常，还是找个地方安放情绪，都能在这里找到同好，随手发帖、随时回帖。",
  email: "hi@guatian-community.example",
  workTime: "每天 09:00 - 24:00 有值班版主在线",
};

export const siteStats = [
  { label: "注册瓜友", value: "128.6万", icon: "ri-group-line" },
  { label: "今日新帖", value: "9,412", icon: "ri-quill-pen-line" },
  { label: "在线讨论", value: "23,508", icon: "ri-live-line" },
  { label: "累计回帖", value: "3,860万", icon: "ri-chat-smile-2-line" },
];

export const hotSearchWords = [
  "今日话题",
  "热帖推荐",
  "讨论版精华",
  "发帖互动",
  "回帖讨论",
  "大家聊",
  "吃瓜第一线",
  "生活茶话会",
];

export const communityValues = [
  {
    icon: "ri-emotion-happy-line",
    title: "聊得轻松",
    desc: "没有 KPI，也没有客套，想到什么就聊什么，一句话也能成为好帖的开头。",
  },
  {
    icon: "ri-shield-check-line",
    title: "聊得安心",
    desc: "版主每日巡版，先聊感受再谈观点，拒绝攻击与人身伤害，让每个人都有安全感。",
  },
  {
    icon: "ri-fire-line",
    title: "聊得新鲜",
    desc: "今日话题每天更新，热帖榜单实时滚动，永远有正在发生的讨论等你加入。",
  },
  {
    icon: "ri-plant-line",
    title: "聊得长久",
    desc: "从一条吐槽到一群同好，很多瓜友在这里认识了好几年的朋友，这才是社区的意义。",
  },
];